export default __webpack_public_path__ + "static/media/sc-bi-ico.11dcfb88.svg";